import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Authorization service
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  /**
   * behavior subject for isLoggedIn
   */
  isLoggedIn = new BehaviorSubject(false);

  /**
   * constructor to inject dependency
   */
  constructor() {}
}
